import Global from '@/scripts/Global'
import VueSignals from '@/scripts/VueSignals'
import ChannelThumbNail from '@/components/LeftSidebar/ChannelThumbNail/ChannelThumbNail.vue';
import {
    serverBus
} from '@/main'

export default {
    name: 'StarredChannels',
    data: function() {
        return {}
    },
    props: {
        channels: Array,
        activeChannelDoc: Object,
        AlertedChannelsList: Array,
        arrMentions: Array,
        withMessagePreview: {
            type: Boolean,
            default: false
        }
    },
    filters: {
        formatName(name) {
            return name ? (name.length >= 15 ? `${name.slice(0,15)}..` : name) : '';
        }
    },
    components:{
        ChannelThumbNail
    },
    mounted() {
        serverBus.$on(VueSignals.REMOVE_ALL_MENTIONS, (channel_id) => {
            for (let k = 0; k < this.arrMentions.length; k++) {
                if (this.arrMentions[k].channel_id == channel_id) {
                    this.arrMentions[k].count = 0
                }
                Global.setFaviconNormal()
                for (let i = 0; i < this.AlertedChannelsList.length; i++) {
                    if (this.AlertedChannelsList[i] == channel_id) {
                        this.AlertedChannelsList.splice(i, 1)
                        break
                    }
                }
            }
        })
    },
    methods: {
        loadChannel(channel_id) {
            Global.globalValue(VueSignals.LOADED_CHANNEL_ID, channel_id)
        }
    }
}
